module.exports = __webpack_public_path__ + "static/actor_diagram-d3c50706e78f35d9050690c9e0ff6fe6.png";